import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Table from "./Table";
import printerimg from "../../../../assets/print.png"
import {
    useGetPurchaseOrderByNameMutation, useGetVendorListMutation,
    useGetVendorAddressListMutation, usePostItemListMutation,
    usePostSubmitPurchaseOrderMutation, useUpdatePurchaseOrderMutation,
    useGetAllShippingAddressesMutation
} from "../../../../store/api/purchaseorderapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import PrintModal from "../../../../Core/Print/PrintModal";
import BulkUpload from "../Create-Purchase-Order/BulkUpload";
import { useGetPriceListQuery } from "../../../../store/api/pricelistapi";
import { useGetCurrencyListQuery } from "../../../../store/api/customer";
import { useGetProjectListQuery } from "../../../../store/api/projectapi";
import { useGetCostCenterListQuery } from "../../../../store/api/costcenterapi";
import { useGetPurchaseTaxCategoryListQuery } from "../../../../store/api/taxcategoryapi";
import { useGetTermsandConditionQuery } from "../../../../store/api/termsandconditionapi";
import { useGetPaymentTermsQuery } from "../../../../store/api/paymenttermapi";
import Attachment from "../../../../utils/Attachment";
import { useGetSelectedCompanyQuery } from "../../../../store/api/companyapi";
import { RMcurrentGrnId } from "../../../../Localstorage/Localstorage";
import { useGetGateEntryEnableMutation } from "../../../../store/api/gateentryapi";

function EditPurchase() {
    const navigate = useNavigate()
    const [tab, settab] = useState(1)
    const [podate, setpodate] = useState('')
    const [refetchpodata, setrefetchpodata] = useState(true)
    const location = useLocation();
    const PurchaseData = location.state?.PurchaseId;
    const [error, setError] = useState('');
    const [podata, setpodata] = useState('');
    const [rows, setRows] = useState([]);
    const [shipAddr, setShippaddr] = useState([]);
    const [showpopup, setShowpopup] = useState(false);
    const [shipping_address, setShipping_address] = useState({})
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [lines, setLines] = useState(0)
    const [allitems, setAllitems] = useState([])
    const [status, setStatus] = useState('')
    const [ptype, setptype] = useState("Error") 
    const [finalstep, setfinalstep] = useState(false);
    const [isUpdated, setisUpdated] = useState(false);
    const [showError, setShowError] = useState(false);
    const [vendor_list, setvendor_list] = useState([]);
    const [po_response, setpo_response] = useState("");
    const [select_vendor, setselect_vendor] = useState("");
    const [required_date, setrequired_date] = useState("");
    const [selected_item_data, setselected_item_data] = useState([]);
    const [select_vendor_address, setselect_vendor_address] = useState({});
    const [vendor_address_list, setvendor_address_list] = useState([]);
    const [activityboll, setactivityboll] = useState(false)
    const [fieldErrors, setFieldErrors] = useState({
        vendor: false,
        vendor_address: false,
        required_date: false,
        items: false
    });
      const [getallshipaddress] = useGetAllShippingAddressesMutation();
      const { data } = useGetSelectedCompanyQuery();
      const selectedComapny = data?.message?.data?.company;
    const { data: p_term } = useGetPaymentTermsQuery();
    const { data: tandc } = useGetTermsandConditionQuery();
    // const { data: taxandchangeslist } = useGetTaxCategoryListQuery();
    const { data:taxandchangeslist } = useGetPurchaseTaxCategoryListQuery(selectedComapny);
       const filters = [
        ["company", "=", selectedComapny?.split(" - ")[0]],
        ["disabled", "=", 0],
        // ["is_group", "=", 0]
      ];
      const { data:costcenterlist } = useGetCostCenterListQuery({filters: JSON.stringify(filters)});
    const { data: projectlist } = useGetProjectListQuery();
    const { data: currencylist } = useGetCurrencyListQuery();
    const { data: pricelist } = useGetPriceListQuery({ filters: JSON.stringify({ buying: 1 }) });
    const [isGateEntryEnabled] = useGetGateEntryEnableMutation();
    
    const [getvendor_list] = useGetVendorListMutation();
    const [getvendor_address_list_data] = useGetVendorAddressListMutation();
    const [getitem_list_data] = usePostItemListMutation();
    const [Submit_Purchase] = usePostSubmitPurchaseOrderMutation();
    const [updatePurchaseOrder] = useUpdatePurchaseOrderMutation()
    const [taxandchanges, settaxandchanges] = useState('');
    const [cost_center, setcost_center] = useState('');
    const [project, setproject] = useState('');
    const [currency, setcurrency] = useState('');
    const [pricel, setpricel] = useState('');
    const [paymentterm, setpaymentterm] = useState("");
    const [termsandcondition, settermsandcondition] = useState("");
    const [asn_inclusion, setasn_inclusion] = useState(false);
    const [isGateEntryChecked, setIsGateEntryChecked] = useState(false)
    

    const getVendorAndWarehouse = async () => {
        const venderApiData = await getvendor_list()
        setvendor_list(venderApiData.data.result);
    }

    const getVendor_Address = async () => {
        try {
            const vendorAddressApiData = await getvendor_address_list_data({ vendor: select_vendor })
            setvendor_address_list(vendorAddressApiData.data.result);
            setselect_vendor_address(vendorAddressApiData.data.result?.[0])
        } catch (error) {
            console.log("check error", error)
        }
    }

    const handleEdit = async (id) => {
        navigate(`/inbound/purchaseorder/duplicate-purchase-order`, { state: { PurchaseId: PurchaseData } });
    };

    const [getPurchaseOrderByName] = useGetPurchaseOrderByNameMutation();


    useEffect(() => {
        if (PurchaseData) {

            getPurchaseOrderByName({ doctype: 'Purchase Order', name: PurchaseData })
                .unwrap()
                .then((response) => {
                    setpodata(response)
                    setactivityboll(true)

                    setStatus(response.message.wms_status == null ? response.message.status : response.message.wms_status)
                   

                    let apistatus = response.message.wms_status == null ? response.message.status : response.message.wms_status;
                    setStatus(apistatus)
                    if(apistatus !== "Draft"){
                        setisUpdated(true)
                    }

                    setselect_vendor(response.message.supplier_name)
                    setLines(response.message.items.length)
                    setpodate(response.message.transaction_date)
                    setrequired_date(response.message.schedule_date)
                    setShipping_address({name:response.message.shipping_address})
                    setAllitems(response.message.items)
                    setRows(response.message.items.map(item => ({
                    item_code: item.item_code,
                    item: {
                    item_code: item.item_code,
                    item_name: item.item_name,
                    stock_uom: item.stock_uom,
                    buying_price: item.rate,
                    item_group:item.item_group,
                    custom_category:item.custom_category
                    },
                    quantity: item.qty,
                    uom: item.stock_uom,
                    rate: item.rate,
                    amount: item.base_amount
                    })))
                    setselected_item_data(response.message.items.map(item => ({
                    item_code: item.item_code,
                    item: {
                    item_code: item.item_code,
                    item_name: item.item_name,
                    stock_uom: item.stock_uom,
                    buying_price: item.rate,
                    item_group:item.item_group,
                    custom_category:item.custom_category
                },
                    quantity: item.qty,
                    uom: item.stock_uom,
                    rate: item.rate,
                    amount: item.base_amount
                    })))
                    setcurrency(response.message?.currency)
                    setproject(response.message?.project)
                    setpricel(response.message?.buying_price_list)
                    setcost_center(response.message?.cost_center)
                    settermsandcondition(response.message?.tc_name)
                    settaxandchanges(response.message?.taxes_and_charges)
                    setpaymentterm(response.message?.payment_terms_template)

                    setasn_inclusion(response.message?.custom_include_in_asn == 1);
                    // setfinalstep(response.message)
                    


                })

                .catch((err) => {
                    console.error('API Error:', err);
                });
        } else {
            console.warn('No PurchaseData found in location state');
        }
    }, [refetchpodata ,PurchaseData, getPurchaseOrderByName]);


    useEffect(() => {
    const fetchshipaddress = async () =>{
        try {
              const response = await getallshipaddress({ company_name: selectedComapny.split(' - ')[0] });
              const names = response.data?.message.map((item) => ({ name: item.name }));
              setShippaddr(names);
        } catch (error) {
             console.log("shiping address eror");
        }
    }

    fetchshipaddress();
  }, [selectedComapny]);

    const filter_Item_Data = selected_item_data.map(item => ({
        item_code: item.item_code,
        quantity: item.quantity,
        rate: item.rate
    }));


    const handleUpdate = async () => {
        const payload = {

            purchase_order_id: PurchaseData,

            schedule_date: required_date,
            vendor: select_vendor,
            // vendor_address:select_vendor_address,
            items: filter_Item_Data,
            "currency": currency,
            "price_list": pricel,
            "cost_center": cost_center,
            "project": project,
            "shipping_address": shipping_address ? shipping_address.name : "",
            "tax_category": taxandchanges,
            "payment_terms_template": paymentterm,
            "terms_and_conditions": termsandcondition,
              "asn_inclusion": asn_inclusion ? 1 : 0

        };

        try {
            const response = await updatePurchaseOrder(payload).unwrap();
            setisUpdated(true);
            setrefetchpodata(!refetchpodata);
            setpo_response(response);
            setptype("Message")
            setError("Purchase Updated Successfully");
            setTimeout(() => {
                // navigate('/inbound/purchaseorder/purchase-orders')
                setShowError(true);
            }, 2000);
        } catch (err) {
            const apiErrors = [];
            if (err?.data?.message) {
                const serverMessages = JSON.parse(err?.data?._server_messages);
                if (serverMessages.length > 0) {
                    const firstMessage = JSON.parse(serverMessages[0]);
                    apiErrors.push(firstMessage.message);
                }
            } else if (err?.message) {
                apiErrors.push(err?.message);
                const serverMessages = JSON.parse(err?._server_messages);
                if (serverMessages.length > 0) {
                    const firstMessage = JSON.parse(serverMessages[0]);
                    apiErrors.push(firstMessage.message);
                }
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
    };

    const SubmitPurchaseOrder = async () => {
        try {
            const ResponseData = await Submit_Purchase({ "purchase_order_name": PurchaseData })
            const res = await isGateEntryEnabled({ po_name: PurchaseData });

            setptype("Message")
            setError("Purchase Order Sumbit Successfully");
            setShowError(true);
            setIsGateEntryChecked(res.data.message);
			setfinalstep(true);
            setTimeout(() => {
                setptype("")
                setError("");
                setShowError(false);
            }, 4000);
        } catch (err) {
            const apiErrors = [];
            if (err?.data?.message) {
                const serverMessages = JSON.parse(err?.data?._server_messages);
                if (serverMessages.length > 0) {
                    const firstMessage = JSON.parse(serverMessages[0]);
                    apiErrors.push(firstMessage.message);
                }
            } else if (err?.message) {
                apiErrors.push(err?.message);
                const serverMessages = JSON.parse(err?._server_messages);
                if (serverMessages.length > 0) {
                    const firstMessage = JSON.parse(serverMessages[0]);
                    apiErrors.push(firstMessage.message);
                }
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
        finally {
            console.log("Set Final",finalstep)
        }
    }

    useEffect(() => {
        getVendor_Address()
    }, [select_vendor])

    useEffect(() => {
        getVendorAndWarehouse()
    }, [])

    return (
        <FormLayout
            title="Edit Purchase Order"
            breadcrumbs={[
                { label: "Inbound" },
                { label: "Purchase Order List", url: "/inbound/purchaseorder/purchase-orders" }
            ]}
            status={status}
            finalStep={finalstep}
            actionButtons={
                <>
                    { isGateEntryChecked ? (
						<Button
							onClick={() => {
								RMcurrentGrnId();
							}}
							to="/inbound/gate-entry/create-gate-entry"
							state={PurchaseData}
							style={{ backgroundColor: "#fff", height: "28px" }}
							className="custom-btn-00989blue"
							display={finalstep || status === "To Receive and Bill" || status === "Partially Receipt" || status === "Completely Receipt" ? 'flex' : 'none'}
						>
							+ Create Gate Entry
						</Button>
					    ) : (
                            <Button
                                onClick={() => {
                                    RMcurrentGrnId();
                                }}
                                to="/inbound/grn/create-purchase-receipt"
                                state={PurchaseData}
                                style={{ backgroundColor: "#fff", height: "28px" }}
                                className="custom-btn-00989blue"
                                display={finalstep || status === "To Receive and Bill" || status === "Partially Receipt" || status === "Completely Receipt" ? 'flex' : 'none'}
                            >
                                + Create GRN
                            </Button>
                        )
                    }

                    <Button
                        className="custom-btn-bluecolor"
                        iconName="BiCloudUpload"
                        style={{ gap: '2px' }}
                        iconSize={14}
                        onClick={() => { setShowpopup(true) }}
                        display={finalstep || status === "To Receive and Bill" || status === "Partially Receipt" || status === "Completely Receipt" ? 'none' : 'flex'}

                    >
                        Upload
                    </Button>
                    <Button
                        onClick={handleEdit}
                        className="createbtn d-flex"
                        style={{ gap: '2px', height: '28px' }}
                        iconName="GrCopy"
                        iconSize={12}
                    >
                        Duplicate
                    </Button>
                    
                        <Button
                            className="custom-btn-00989"
                            onClick={handleUpdate}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}
                            display={finalstep || status == "To Receive and Bill" || status == "Partially Receipt" || status == "Completely Receipt" ? 'none' : 'flex'}
                        >
                           Update
                        </Button>

                        <Button
                            className="custom-btn-00989"
                            onClick={SubmitPurchaseOrder}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}
                            display={finalstep || status == "To Receive and Bill" || status == "Partially Receipt" || status == "Completely Receipt" ? 'none' : 'flex'}
                        >
                            Submit
                        </Button>

                    <p className="p-0 m-0">
                        <img src={printerimg}
                            onClick={() => setShowPrintModal(true)}
                            className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
                    </p>
                </>
            }
        >
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                            <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                                <a className={tab == 2 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                                    Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        <Attachment
                          doctype="Purchase Order"
                          docname={PurchaseData}
                        />
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    {tab != 1 ? "" : <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1
                            // read={isUpdated}
                            read={false}
                            activityboll={activityboll}
                            status={status}
                            purchasename={PurchaseData}
                            vendor={{ vendor_list: vendor_list, setselect_vendor: setselect_vendor, select_vendor: select_vendor, Error: fieldErrors.vendor }}
                            selectedAddress={{ list: vendor_address_list, currentAddress: select_vendor_address, Error: fieldErrors.vendor_address }}
                            required_date={{ setrequired_date: setrequired_date, required_date: required_date, Error: fieldErrors.required_date }}
                            podate={{ podate: podate, setpodate: setpodate }}
                            ponumber={po_response?.result}
                            pTerms={{ paymentterm: paymentterm, setpaymentterm: setpaymentterm, list: p_term?.data }}
                            termandcondition={{ termsandcondition, settermsandcondition, list: tandc?.data }}
                            taxandchanges={{ list: taxandchangeslist?.data, setvalue: settaxandchanges, value: taxandchanges }}
                            cost_center={{ list: costcenterlist?.data, setvalue: setcost_center, value: cost_center }}
                            project={{ list: projectlist?.data, setvalue: setproject, value: project }}
                            currency={{ list: currencylist?.data, setvalue: setcurrency, value: currency }}
                            price={{ list: pricelist?.data, setvalue: setpricel, value: pricel }}
                            setasn_inclusion={setasn_inclusion}
                            asn_inclusion={asn_inclusion}

                        />
                    </div>}

                    {tab != 1 ? "" : <div className="col-9 d-flex flex-column mt-2 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
                        <div className="d-flex pb-2" style={{ gap: '5px' }}>
                            <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {selected_item_data.length}</span></p>
                            <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {selected_item_data.reduce((total, item) => { return total + Number(item.quantity); }, 0)}</span></p>
                            <p className="ReceivedQty" style={{ display: po_response.result ? '' : 'none' }}>Received Quantity -  <span style={{ color: '#EC642A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}</span></p>
                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p className="" style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>

                        </div>      
                    
                        <Table
                        //  read={isUpdated} 
                         read={false} 
                         status={status}
                         setselected_item_data={setselected_item_data}
                          allitems={allitems} list_data={getitem_list_data}
                           po_status={po_response} 
                           rows={rows} setRows={setRows} />

                        {status !== 'Draft' ? (
                            <div className=" mt-auto  pb-2" >
                                <div className="row ">
                                    <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        <div style={{ width: '20%' }}>
                                            <p className="TotalQtywithoutBg">
                                                Ordered Quantity -
                                                <span style={{ color: '#EC642A' }}>
                                                    {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '18%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Total Value -
                                                <span style={{ color: '#FF5969' }}>
                                                    {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.rate), 0)}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '24%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Tax Type -
                                                <span style={{ color: '#C40AB8' }}>
                                                    {podata.message?.taxes.length == 0 ? '' : podata.message?.taxes.reduce((acc, curr) => {
                                                                                        if (!acc.includes(curr.description)) {
                                                                                            acc.push(curr.description);
                                                                                        }
                                                                                        return acc;
                                                                                        }, []).join(', ')}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '15%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Tax -
                                                <span style={{ color: '#2563EB' }}>
                                                     {podata.message?.total_taxes_and_charges}

                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '22%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Grand Total -
                                                <span style={{ color: '#16A34A' }}>
                                                    {podata.message?.grand_total}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>) :
                            <div className=" mt-auto pb-2" >
                                <div className="row " style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <div style={{ width: '20%' }}>
                                        <p className="TotalQtywithoutBg">
                                            Ordered Quantity -
                                            <span style={{ color: '#EC642A' }}>
                                                {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}
                                            </span>
                                        </p>
                                    </div>

                                    <div style={{ width: '18%' }}>
                                        <p className="NoOfLinewithoutBg">
                                            Total Value -
                                            <span style={{ color: '#FF5969' }}>
                                                {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.rate), 0)}
                                            </span>
                                        </p>
                                    </div>

                                    <div style={{ width: '24%' }}>
                                        <p className="NoOfLinewithoutBg">
                                            Tax Type -
                                            <span style={{ color: '#C40AB8' }}>
                                           {podata.message?.taxes.length == 0 ? '' : podata.message?.taxes.reduce((acc, curr) => {
                                                                                        if (!acc.includes(curr.description)) {
                                                                                            acc.push(curr.description);
                                                                                        }
                                                                                        return acc;
                                                                                        }, []).join(', ')}
                                            </span>
                                        </p>
                                    </div>

                                    <div style={{ width: '15%' }}>
                                        <p className="NoOfLinewithoutBg">
                                            Tax -
                                            <span style={{ color: '#2563EB' }}>
                                            {podata.message?.total_taxes_and_charges}
                                            </span>
                                        </p>
                                    </div>

                                    <div style={{ width: '22%' }}>
                                        <p className="NoOfLinewithoutBg">
                                            Grand Total -
                                            <span style={{ color: '#16A34A' }}>
                                                    {podata.message?.grand_total}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>}
                    </div>}


                    {tab != 2 ? "" : <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px' }}>
                        <Tab2 
                        //  read={isUpdated} 
                        //  status={status} 
                         vendor_address={{ vendor_address_list: vendor_address_list, setselect_vendor_address: setselect_vendor_address, currentAddress: select_vendor_address }}
                         shippingAddr={{ setVendorshipAddress: setShipping_address, shippingAddresseslist: shipAddr,currentAddress:shipping_address }} 
                         />
                    </div>}

                </div>
            </div>

            {showPrintModal && (
                <PrintModal
                    onClose={() => setShowPrintModal(false)}
                    documentId={PurchaseData}
                    doctype="Purchase Order"
                    title="Print Purchase Order"
                />
            )}

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />

            <BulkUpload
                show={showpopup}
                onClose={() => setShowpopup(false)}
                rows={rows}
                setRows={setRows}
                setselected_item_data={setselected_item_data}
            />
        </FormLayout>
    )
}

export default EditPurchase
